import api from './api';

/** Smart-Money copy-signal API client (Phase 1: Hyperliquid). Suggest-only. */
export const copyTradeService = {
  getConfig: () => api.get('/copytrade/config'),
  updateConfig: (patch: Record<string, any>) => api.put('/copytrade/config', patch),
  getSignals: (status = 'ACTIVE', source = 'ALL', limit = 60) => api.get('/copytrade/signals', { params: { status, source, limit } }),
  ingestNse: (source: string, text: string) => api.post('/copytrade/nse/ingest', { source, text }),
  getTraders: (discover = false) => api.get('/copytrade/traders', { params: discover ? { discover: 'true' } : {} }),
  getPositioning: () => api.get('/copytrade/positioning'),
  addTrader: (address: string) => api.post('/copytrade/traders', { address }),
  setFollow: (id: number, follow: boolean) => api.post(`/copytrade/traders/${id}/follow`, { follow }),
  setSignalStatus: (id: number, status: string) => api.post(`/copytrade/signals/${id}/status`, { status }),
  refreshNow: () => api.post('/copytrade/refresh'),
};
